import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Printer } from 'lucide-react';
import EoaEExperience from './EoaEExperience';
import StoryShareButton from './StoryShareButton';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// PUBLIC, no-auth viewer for /share/eoae/:token
const EoaEPublicPage = () => {
  const { token } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Bare axios instance — do NOT send the app's auth header on a public link
    const client = axios.create();
    delete client.defaults.headers.common['Authorization'];
    client.get(`${API}/eoae/public/${token}`)
      .then((res) => setReport(res.data))
      .catch(() => setError('Este informe no está disponible.'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37]" />
      </div>
    );
  }
  if (error || !report) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <p className="font-manrope text-red-300">{error || 'Informe no encontrado'}</p>
      </div>
    );
  }

  return (
    <div className="eoae-root bg-[#050505]">
      <div className="no-print fixed top-4 right-4 z-50 flex gap-3">
        <StoryShareButton report={report} />
        <button
          onClick={() => window.print()}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#D4AF37] text-black text-sm font-semibold font-manrope hover:bg-[#e3c14f] transition"
          data-testid="eoae-public-print-btn"
        >
          <Printer className="w-4 h-4" /> Exportar PDF
        </button>
      </div>
      <EoaEExperience report={report} printMode={false} />
    </div>
  );
};

export default EoaEPublicPage;
